// ---------------------------------------------------------------------------
// withdrawGate.js — Phase A Run 2 lifecycle helpers (frontend).
//
// Provides tiny client-side predicates so pages can disable buttons and
// show badges without duplicating the enum in multiple places. Backend
// remains the source of truth — every gated action is also enforced
// server-side.
// ---------------------------------------------------------------------------

export const LIFECYCLE_STATES = {
  ACTIVE: "ACTIVE",
  DRAFT: "DRAFT",
  ARCHIVED: "ARCHIVED",
  WITHDRAWN: "WITHDRAWN",
  CANCELLED: "CANCELLED",
  SUPERSEDED: "SUPERSEDED",
  DUPLICATE_ERROR: "DUPLICATE_ERROR",
};

export const LIFECYCLE_BLOCKED = new Set([
  "ARCHIVED", "WITHDRAWN", "CANCELLED", "DUPLICATE_ERROR",
]);

export function getLifecycleStatus(record) {
  if (!record) return "ACTIVE";
  const raw = (record.lifecycle_status || "").toString().trim().toUpperCase();
  return raw || "ACTIVE";
}

export function isLifecycleBlocked(record) {
  return LIFECYCLE_BLOCKED.has(getLifecycleStatus(record));
}

export function isTrackBlockedForNewWork(track) {
  return isLifecycleBlocked(track);
}

export function lifecycleBadgeVariant(state) {
  const s = (state || "ACTIVE").toUpperCase();
  switch (s) {
    case "WITHDRAWN":       return { label: "Withdrawn",  className: "bg-red-100 text-red-900 border-red-300" };
    case "ARCHIVED":        return { label: "Archived",   className: "bg-slate-200 text-slate-800 border-slate-300" };
    case "CANCELLED":       return { label: "Cancelled",  className: "bg-slate-200 text-slate-800 border-slate-300" };
    case "SUPERSEDED":      return { label: "Superseded", className: "bg-amber-100 text-amber-900 border-amber-300" };
    case "DUPLICATE_ERROR": return { label: "Duplicate Error", className: "bg-rose-100 text-rose-900 border-rose-300" };
    case "DRAFT":           return { label: "Draft",      className: "bg-blue-50 text-blue-800 border-blue-200" };
    case "ACTIVE":
    default:                return { label: "Active",     className: "bg-emerald-50 text-emerald-800 border-emerald-200" };
  }
}
